import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { Space, Table, Tag, Button, Statistic, Divider } from 'antd';
import { Modal, Col, Form, Row } from 'react-bootstrap';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import { FcUndo, FcRefresh, FcFlowChart, FcRules, FcViewDetails } from "react-icons/fc";
import ViewModal from '../../../components/modals/viewModal';





const InvoicePayments = (props) => {

    const { setJournalVoucher, journalVoucher, remaining, secondaryRemaining, totalPaid, secondaryTotalPaid, invoices } = props;

    const { api, userData, settingData, defaultCurrency, secondaryCurrency, mainCurrency } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);

    const selectedJv = invoices?.find(invoice => invoice.id == journalVoucher?.invoiceId)
    const data = selectedJv?.payments;

    const isUsingMainCurrency = defaultCurrency.id == mainCurrency.id ? true : false;


    const viewModal = (e) => {
        setShowViewModal(!showViewModal);
    }


    // Invoice Options
    const invoiceOptions = invoices?.map(item => ({
        value: item.id,
        label: isUsingMainCurrency ?
            ('ID: ' + item.id + ' / ' + item.date + ' Total:  ' + item.totalCredit + mainCurrency.code + ' [' + item.status + ']') :
            ('ID: ' + item.id + ' / ' + item.date + ' Total:  ' + item.secondaryTotalCredit + secondaryCurrency.code + ' [' + item.status + ']')
    }));

    // handle select change
    const handleSelectChange = (selectedOption, name) => {
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: selectedOption?.value,
        }));
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
        },
        {
            title: 'Type',
            dataIndex: 'type',
        },
        {
            title: 'Date',
            dataIndex: 'date',
        },
        {
            title: 'Total ',
            dataIndex: 'totalDebit',
            render: numberFormatter,
        },
        {
            title: 'Total ',
            dataIndex: 'secondaryTotalDebit',
            render: numberFormatter,
        },
    ]

    return (

        <div style={{ display: 'flex', gap: '10%' }}>

            <div style={{ width: '45%' }}>
                <Row className="mb-3">

                    {/* Invoice */}
                    <Col md={2}>
                        <Form.Label>Invoice<span style={{ color: 'red' }}>*</span></Form.Label>
                    </Col>
                    <Col md={9}>
                        <Select
                            options={invoiceOptions}
                            isSearchable={true}
                            placeholder="Select"
                            onChange={(e) => handleSelectChange(e, 'invoiceId')}
                            value={invoiceOptions?.find(option => option.value === journalVoucher.invoiceId) || []}
                            required
                        />
                    </Col>
                    {journalVoucher.invoiceId &&
                        <Col md={1}>
                            <FcViewDetails size={25} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal()} />
                        </Col>
                    }
                </Row>
                <Row>
                    <Col md={2}>
                        <p>Total:</p>
                    </Col>
                    <Col>
                        <p>{isUsingMainCurrency ? (numberFormatter(selectedJv?.totalCredit) + mainCurrency?.symbol) : (numberFormatter(selectedJv?.secondaryTotalCredit) + secondaryCurrency?.symbol)}</p>
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <p>Paid:</p>
                    </Col>
                    <Col>
                        <p>{isUsingMainCurrency ? (numberFormatter(totalPaid) + mainCurrency?.symbol) : (numberFormatter(secondaryTotalPaid) + secondaryCurrency?.symbol)}</p>
                    </Col>
                </Row>
                <Divider />
                <Row>
                    <Col md={2}>
                        <p style={{ fontWeight: 'bold' }}>Remainig:</p>
                    </Col>
                    <Col>
                        <p>{isUsingMainCurrency ? (numberFormatter(remaining) + mainCurrency?.symbol) : (numberFormatter(secondaryRemaining) + secondaryCurrency?.symbol)}</p>
                    </Col>
                </Row>
            </div>
            <div style={{ width: '45%' }}>
                <Table columns={columns} dataSource={data} pagination={false} />
            </div>


            <ViewModal
                showModal={showViewModal}
                toggleModal={viewModal}
                journalVoucherId={journalVoucher.invoiceId}
            />



        </div>


    )
}


export default InvoicePayments;